import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-support-journey',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './support-journey.component.html',
  styleUrl: './support-journey.component.scss',
})
export class SupportJourneyComponent {
  @Input() userLoggedIn = false;
}
